export enum Color {
  Red = '#FF0000',
  Green = '#31C048',
  Blue = '#005AFF',
  Orange = '#FF8A00',
  Pink = '#FF4FF3',
  Yellow = '#FCFF00',
  Gray = '#7D7D7D',
  TitleGray = '#989898',
  White = '#FFFFFF',
  Black = '#000000',
  Transparent = 'transparent'
}
